import { Navigate } from "react-router-dom";
import classNames from "classnames/bind";

import { adminRouteAbsolute } from "~/utils/constants/route";
import { StorageEnum } from "~/utils/enum";
import styles from "./Main.module.scss";
import Header from "./header/Header";
import Content from "./content/Content";

const cx = classNames.bind(styles);

export default function MiniDrawer() {
  const accessToken = localStorage.getItem(StorageEnum.ACCESS_TOKEN);
  const isLoggedIn = !!accessToken;

  return isLoggedIn ? (
    <div className={cx("layout-main")}>
      <div className={cx("header-container")}>
        <Header />
      </div>
      <div className={cx("content-container")}>
        <Content />
      </div>
    </div>
  ) : (
    <Navigate to={adminRouteAbsolute.login} replace />
  );
}
